export default __webpack_public_path__ + "static/media/LogoElte.f6292997.svg";